import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Modal,
  Button,
  Space,
  Col,
  Select,
  Image,
  Input,
} from 'antd';
import { message, FormLabel, InputInteger } from 'components/common';
import { LoadingOutlined, SaveOutlined, EditOutlined, CloseOutlined } from '@ant-design/icons';
import { getAllPackageList } from 'services/shipment';
import {
  updateProductDefaultPackage,
  getDefaultpackageId,
} from 'services/product';
import {
  WEIGHT_UNITS as weightUnitEnum,
  DIMENSION_UNITS as unitEnum,
  PERMISSION_LEVEL,
} from 'constants/config';

interface ProductPackageProps {
  visible: boolean;
  onHide: () => void;
  onRefresh: () => void;
  product?: ProductRow;
  managePermission: number
}

// eslint-disable-next-line
export default (props: ProductPackageProps) => {
  const { visible, onHide, onRefresh, product, managePermission } = props;
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [packages, setPackages] = useState<any[]>([]);
  const [selectedPakage, setSelectedPakcge] = useState<any>();
  const [editAble, setEditAble] = useState(false);
  const [info, setInfo] = useState<any>();
  const [packageId, setPackageId] = useState<number>();
  const [isOriginPackage, setIsOriginPacakge] = useState(false);
  // const [packageMaxQty, setPackageMaxQty] = useState<number>();

  const [form] = Form.useForm();
  document.body.style.overflowY = 'hidden';

  const handleSubmit = async () => {
    if (!editAble) {
      setEditAble(true);
      return;
    }
    const params = await form.validateFields();
    console.log('params', params);
    if (params.errorFields) return;
    if (!product || !product.id) {
      message.error({
        content: 'invalid product',
      });
      return;
    }

    try {
      setSubmitLoading(true);
      const res = await updateProductDefaultPackage({
        FulfillmentProductNum: product.id,
        ...params,
      });
      setSubmitLoading(false);
      if (res.isSuccess) {
        message.success({
          content: 'Saved successfully',
        });
        document.body.style.overflowY = 'unset';
        onRefresh();
        onHide();
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const getDefaultPackage = async () => {
    if (!product || !product.id) {
      message.error({
        content: 'invalid product',
      });
      return;
    }
    try {
      setLoading1(true);
      const res = await getDefaultpackageId(product.id);
      setLoading1(false);
      if (res.isSuccess) {
        setInfo(res.data);
        setPackageId(res.data.shippingCustomPackageNum);
        if (res.data.shippingCustomPackageNum === 1) {
          setIsOriginPacakge(true);
        }
        // setPackageMaxQty(res.data.packageMaxQty || 1);
      }
    } catch (error) {
      setLoading1(false);
    }
  };

  const getPackageList = async () => {
    try {
      setLoading(true);
      const res = await getAllPackageList();
      setLoading(false);
      setPackages(
        res.filter(
          (i) => i.shippingCustomPackageNum || i.shippingCustomPackageNum === 0
        )
      );
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      document.body.style.overflowY = 'unset';
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        afterClose: () => {
          //fuck antd bug!
          setTimeout(() => {
            document.body.style.overflowY = 'unset';
          }, 0);
        },
        content: `Changes you made may not be saved.`,
        onOk() {
          onHide();
        },
      });
    }
  };
  /* eslint-disable */
  useEffect(() => {
    getDefaultPackage();
    getPackageList();
  }, []);
  useEffect(() => {
    if (packageId && packages) {
      const temp = packages.filter(
        (i) => i.shippingCustomPackageNum === packageId
      );
      if (temp.length > 0) {
        setSelectedPakcge(temp[0]);
      }
    }
  }, [packageId, packages]);
  /* eslint-enable */
  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 },
  };
  return (
    <Modal
      title="Package / Weight"
      centered
      visible={visible}
      maskClosable={false}
      width={900}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            {
              managePermission >= PERMISSION_LEVEL['EDIT'] && (
                <Button
                  id="save_or_edit_button"
                  key="submit"
                  type="primary"
                  onClick={handleSubmit}
                  loading={submitLoading}
                >
                  {editAble ? (
                    <Space>
                      <SaveOutlined />
                      {submitLoading ? 'Saving' : 'Save'}
                    </Space>
                  ) : (
                    <Space>
                      <EditOutlined />
                      Edit
                    </Space>
                  )}
                </Button>
              )
            }
            <Button id="cancel_button" onClick={handleCancel} icon={<CloseOutlined />}>
              Cancel
            </Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={submitLoading || loading || loading1}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form {...layout} form={form}>
          <Row>
            <Col span={16}>
              <Form.Item label={<FormLabel>SKU</FormLabel>}>
                {info?.sku}
              </Form.Item>
              <Form.Item label={<FormLabel>Product Name</FormLabel>}>
                {info?.productTitle}
              </Form.Item>
              <Form.Item label={<FormLabel>UPC</FormLabel>}>
                {info?.upc}
              </Form.Item>

              {editAble && (
                <Form.Item label={<FormLabel>Dimension Unit</FormLabel>}>
                  {unitEnum[info?.dimensionUnit || 0]}
                </Form.Item>
              )}
              <Form.Item
                label={<FormLabel>Product Size</FormLabel>}
                rules={[{ required: true, message: '' }]}
              >
                {editAble ? (
                  <Input.Group compact>
                    <Form.Item
                      noStyle
                      name="ProductLength"
                      initialValue={info?.productLength}
                    // rules={[{ required: true, message: '' }]}
                    >
                      <Input
                        id="product_length_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="L"
                      />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      name="ProductWidth"
                      initialValue={info?.productWidth}
                    // rules={[{ required: true, message: '' }]}
                    >
                      <Input
                        id="product_width_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="W"
                      />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      name="ProductHeight"
                      initialValue={info?.productHeight}
                    // rules={[{ required: true, message: '' }]}
                    >
                      <Input
                        id="product_height_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="H"
                      />
                    </Form.Item>
                  </Input.Group>
                ) : info?.productLength ||
                  info?.productWidth ||
                  info?.productHeight ? (
                  <Space size="middle">
                    <span>{`L: ${info?.productLength || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`W: ${info?.productWidth || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`H: ${info?.productHeight || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                  </Space>
                ) : null}
              </Form.Item>

              <Form.Item
                label={<FormLabel>Box Size</FormLabel>}
                rules={[{ required: true, message: '' }]}
              >
                {editAble ? (
                  <Input.Group compact>
                    <Form.Item
                      noStyle
                      name="BoxLength"
                      initialValue={info?.boxLength}
                      rules={[{ required: isOriginPackage, message: '' }]}
                    >
                      <Input
                        id="box_length_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="L"
                      />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      name="BoxWidth"
                      initialValue={info?.boxWidth}
                      rules={[{ required: isOriginPackage, message: '' }]}
                    >
                      <Input
                        id="box_width_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="W"
                      />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      name="BoxHeight"
                      initialValue={info?.boxHeight}
                      rules={[{ required: isOriginPackage, message: '' }]}
                    >
                      <Input
                        id="box_height_input"
                        type="number"
                        min={0}
                        style={{ width: '33%' }}
                        addonBefore="H"
                      />
                    </Form.Item>
                  </Input.Group>
                ) : (
                  <Space size="middle">
                    <span>{`L: ${info?.boxLength || 0} ${unitEnum[product?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`W: ${info?.boxWidth || 0} ${unitEnum[product?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`H: ${info?.boxHeight || 0} ${unitEnum[product?.dimensionUnit || 0]
                      }`}</span>
                  </Space>
                )}
              </Form.Item>

              {/* {editAble&&<Form.Item label={<FormLabel>Weight Unit</FormLabel>}>
                {weightUnitEnum[info?.weightUnit || 0]}
              </Form.Item>} */}

              <Form.Item label={<FormLabel>Net Weight</FormLabel>}>
                {
                  editAble ?
                    <Form.Item
                      noStyle
                      name="NetWeight"
                      initialValue={info?.netWeight}
                    // rules={[{ required: true, message: '' }]}
                    >
                      <Input
                        id="net_weight_input"
                        type="number"
                        min={0}
                        style={{ width: '100%' }}
                        addonAfter="LB"
                      />
                    </Form.Item>
                    :
                    info?.netWeight
                      ? `${info?.netWeight} ${weightUnitEnum[info?.weightUnit || 0]
                      }`
                      : ''}
              </Form.Item>

              <Form.Item label={<FormLabel>Gross Weight</FormLabel>}>
                {
                  editAble ?
                    <Form.Item
                      noStyle
                      name="GrossWeight"
                      initialValue={info?.grossWeight}
                    // rules={[{ required: true, message: '' }]}
                    >
                      <Input
                        id="gross_weight_input"
                        type="number"
                        min={0}
                        style={{ width: '100%' }}
                        addonAfter="LB"
                      />
                    </Form.Item>
                    :
                    info?.grossWeight
                      ? `${info?.grossWeight} ${weightUnitEnum[info?.weightUnit || 0]
                      }`
                      : ''}
              </Form.Item>

              {(packageId || packageId === 0) && (
                <Form.Item
                  name="ShippingCustomPackageNum"
                  initialValue={packageId}
                  label={<FormLabel>Default Package</FormLabel>}
                  rules={[
                    { required: true, message: 'Please select package !' },
                  ]}
                >
                  <Select
                    id="default_package_select"
                    optionLabelProp="label"
                    disabled={!editAble}
                    dropdownMatchSelectWidth={false}
                    onChange={(num) => {
                      const temp = packages.filter(
                        (i) => i.shippingCustomPackageNum === num
                      );
                      if (temp.length > 0) {
                        setSelectedPakcge(temp[0]);
                        setIsOriginPacakge(num === 1 ? true : false);
                        if (num === 1) {
                          form.setFieldsValue({ PackageMaxQty: 1 });
                        }
                      }
                    }}
                  >
                    {packages.map((i: any) => (
                      <Select.Option
                        key={i.shippingCustomPackageNum}
                        value={i.shippingCustomPackageNum}
                        label={i.name}
                      >
                        {i.shippingCustomPackageNum === 1 ? (
                          <Space>
                            <span>{i.name}</span>
                          </Space>
                        ) : (
                          <Space>
                            <span>{i.name}</span>
                            <span>{` ( L: ${i?.length || 0} ${unitEnum[i?.lengthUnits || 0]
                              }`}</span>
                            <span>{`W: ${i?.width || 0} ${unitEnum[i?.lengthUnits || 0]
                              }`}</span>
                            <span>{`H: ${i?.height || 0} ${unitEnum[i?.lengthUnits || 0]
                              } )`}</span>
                          </Space>
                        )}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}

              <Form.Item label={<FormLabel>Package Size</FormLabel>}>
                {isOriginPackage ? (
                  <span>Pacakge size is the same as the box size</span>
                ) : selectedPakage?.length ||
                  selectedPakage?.width ||
                  selectedPakage?.height ? (
                  <Space size="middle">
                    <span>{`L: ${selectedPakage?.length || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                      }`}</span>
                    <span>{`W: ${selectedPakage?.width || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                      }`}</span>
                    <span>{`H: ${selectedPakage?.height || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                      }`}</span>
                  </Space>
                ) : null}
              </Form.Item>

              {info && (
                <Form.Item
                  name="PackageMaxQty"
                  initialValue={info ? info.packageMaxQty : undefined}
                  label={<FormLabel>Package Max Qty</FormLabel>}
                >
                  <InputInteger
                    id="max_qty_input"
                    disabled={!editAble || isOriginPackage}
                  />
                </Form.Item>
              )}
              {
                info && (
                  <Form.Item
                    name="ShipSeparately"
                    initialValue={info.shipSeparately ?? 0}
                    label={<FormLabel>Ship Separately</FormLabel>}
                  >
                    <Select
                      id="shipSeparately_selector"
                      defaultValue={info.shipSeparately ?? 0}
                      disabled={!editAble || isOriginPackage}
                    >
                      <Select.Option value={0}>No</Select.Option>
                      <Select.Option value={1}>Yes</Select.Option>
                    </Select>
                  </Form.Item>
                )
              }
              {
                info && (
                  <Form.Item
                    name="HoldForPickup"
                    initialValue={info.holdForPickUp ?? 0}
                    label={<FormLabel>Hold for Pick up</FormLabel>}
                  >
                    <Select
                      id="holdForPickup_selector"
                      defaultValue={info.holdForPickUp ?? 0}
                      disabled={!editAble || isOriginPackage}
                    >
                      <Select.Option value={0}>No</Select.Option>
                      <Select.Option value={1}>Yes</Select.Option>
                    </Select>
                  </Form.Item>
                )
              }
            </Col>
            <Col span={8}>
              <Form.Item noStyle label={<FormLabel noColon>{''}</FormLabel>}>
                <Image
                  width={200}
                  src={info?.thumbnailUrl || 'error'}
                  fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};
